/* Single Case Study.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "../../../sass/layouts/page_templates/template-page-case-study.scss";

const SocialShare = {
    browserWidth: window.outerWidth,
    headerHeight: document.querySelector('.rs-header').clientHeight,
    entryContent: document.querySelector('.entry-content'),
    social: document.querySelector('.single-post__social'),
    socialTop: document.querySelector('.single-post__social').offsetTop,
    buttons: document.querySelector('.sharethis-inline-share-buttons'),

    stickySocial: () => {
        (window.scrollY > SocialShare.socialTop - (SocialShare.headerHeight + 60) && SocialShare.browserWidth >= 1024) ? SocialShare.buttons.style.top = (SocialShare.headerHeight + 60) + 'px' : SocialShare.buttons.style.top = 0;
    },

    init: () => {
        window.addEventListener('scroll', SocialShare.stickySocial);
    },
};

SocialShare.init();
